import React from 'react';
import {Navigate, Route, Routes} from 'react-router-dom';
import {Box} from '@mui/system';
import ContaminationDeclarationDetailScreen from "./contaminationDeclarationDetail";

// A declaration is reached through its lifecycle event or the asset page —
// there is no list query, so the bare path has nothing to show.
// The editor sits on the app's light grey surface (#F4F4F4, the `.content-bg`
// tone used for drawer tiles and hero cards) so the white section cards stand out.
const ContaminationDeclarationRoutes = () => {
    return (
        <Box
            sx={{padding: 0, maxWidth: '100%', minHeight: 0, backgroundColor: '#F4F4F4'}}
            flexDirection="column"
            display={'flex'}
            flexGrow={1}
        >
            <Routes>
                <Route path="/:declarationId" element={<ContaminationDeclarationDetailScreen/>}/>
                <Route path="*" element={<Navigate to="/dashboard" replace/>}/>
            </Routes>
        </Box>
    );
};

export default ContaminationDeclarationRoutes;
